import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import attentionIcon from '../../images/attention-icon.svg';
import {goToPageAsync} from '../../LocalCellularTroubleshootingWizardBlockThunk';
import {setIsShowPopup ,reportDWH} from '../../LocalCellularTroubleshootingWizardBlockSlice';
import PageEnum from 'app/Components/Block/LocalCellularTroubleshootingWizardBlock/constant/PageEnum';
import { buildUrlAndOpenSameWindow, prepareUrl } from '../../../../../utilities/StringHelpers/StringHelpers';
import BtnWhiteBlackBorderBigSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import Config from '../../../../../Config';


const ErrorPage = (props) => {

    useEffect(() => {
    }, []);

    function handleOnClickButton(){
        buildUrlAndOpenSameWindow(props.epiBlockData.finalButtonLink);
    }

    function handleOnClickCallBackButton(){
        props.goToPageAsync({pageType: PageEnum.CALLBACK});
    }

    function handleOnClickLink(item){
        props.reportDWH({ actionType: props.dwhWizardName + ' Page', status: 'Ongoing', messageText: props.dwhWizardName + ' Action Link Clicked', param1: item.text });
        prepareUrl(item.link, props.context);
    }

    function handleOnClickOpenPopupBtn(item){
        if(item.isOpenPopUp){
            props.setIsShowPopup(true);
        }
    }

    return (
        <div className="error-page">
            <div className='content'>
                <div className='img-error'>
                    <Image src={props.pageContent.icon} alt='error-icon' />
                </div>
                {props.pageContent.title && <div className='title'> {props.pageContent.title}</div>}
                {props.pageContent.subTitle && <div className='sub-title'> {props.pageContent.subTitle}</div>}
                {props.pageContent.links?.length > 0 &&
                <div className='links-wrapper'>
                    {props.pageContent.links.map((item , i) => (
                      item.isOpenPopUp ? <button key={i} className='open-popup-btn' onClick={() => handleOnClickOpenPopupBtn(item)}>{item.text}</button> : <a key={i} className='link' onClick={() => handleOnClickLink(item)}>{item.text}</a>
                    ))}
                </div>}
                {props.pageContent.alert?.text && (
                  <div className='attention-text-wrapper'>
                    <div className='text-wrapper'>
                      <Image src={attentionIcon} alt='attention icon' />
                      <p className='text'>
                        {props.pageContent.alert?.text}
                        {props.pageContent.alert?.linkObj?.text &&
                        (<a className='attention-link' onClick={() => handleOnClickLink(props.pageContent.alert.linkObj)}>
                            {props.pageContent.alert.linkObj?.text}
                        </a>)}
                      </p>
                    </div>
                  </div>
                )}
                {props.pageContent.isDisplayCallBack &&
                <div className='callback-btn-wrapper'>
                    <div className='callback-title'>נשמח לסייע לך</div>
                    <BtnWhiteBlackBorderBigSize text='תתקשרו אלי' onclick={() => {handleOnClickCallBackButton();}}/>
                </div>}
            </div>
            <div className='button-wrapper'>
                   <BtnWhiteBlackBorderBigSize
                        text={props.epiBlockData.finalButtonText}
                        onclick={() => {
                            handleOnClickButton();
                        }}
                    />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        pageContent: state.localCellularTroubleshootingWizardBlock.pageContent,
        epiBlockData: state.localCellularTroubleshootingWizardBlock.epiBlockData,
        dwhWizardName: state.localCellularTroubleshootingWizardBlock.dwhWizardName
    };
};

const mapDispatchToProps = { goToPageAsync , setIsShowPopup , reportDWH};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
